// Adapted from specter-1 ui/packages/app/src/screens/Coursework.tsx:69-87.
// Tracks the topmost in-view top-level <section data-section-id="…">. The rail
// uses it to filter the glossary by section before applying the
// viewport-block filter (per `01_renderer.md`'s two-level breathing surface).

import { useEffect, useState } from "react";

export function useActiveSection(
  scrollRef: React.RefObject<HTMLElement | null>,
  mainRef: React.RefObject<HTMLElement | null>,
): string | null {
  const [active, setActive] = useState<string | null>(null);

  useEffect(() => {
    const root = scrollRef.current;
    const main = mainRef.current;
    if (!root || !main) return;
    const sections = Array.from(main.querySelectorAll<HTMLElement>("section[data-section-id]"));
    if (sections.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .map((e) => e.target as HTMLElement)
          .sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);
        if (visible[0]) setActive(visible[0].dataset.sectionId ?? null);
      },
      { root, rootMargin: "-20% 0px -65% 0px", threshold: 0 },
    );
    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, [scrollRef, mainRef]);

  return active;
}
